import { DateTime } from 'luxon'

/** Format and ISO date string to the given Luxon format, or 'HH:mm' by default */
export const formatTime = (date: string, format = 'HH:mm') =>
  DateTime.fromISO(date).toFormat(format)

/**
 * Format an ISO date to the given format, using the city name given in zoneId to denote the time zone
 * @example
 * // Returns '13:45 New York'
 * formatTimeWithZone('2019-01-03T13:45:53.530', 'America/New_York')
 * @param date a string containing an ISO datetime
 * @param zoneId an IANA time zone identifier, or undefined to leave out the zone from the formatted string
 * @param format a valid Luxon format string, or undefined to use the default 'HH:mm' (24 hour time with hours padded to 2 digits)
 */
export const formatTimeWithZone = (
  date: string,
  zoneId?: string,
  format = 'HH:mm'
) => {
  const formattedTime = formatTime(date, format)
  if (!zoneId) return formattedTime

  const zoneParts = zoneId.split('/')
  const city = zoneParts[zoneParts.length - 1].replace(/_/g, ' ')
  return `${formattedTime} ${city}`
}
